import React from 'react';
import { SECTIONS, countInSection } from './content';

// Live band conditions, served by hamqsl.com. This was on the original
// Grav site; it is the one external asset on the page and is hidden if
// the request fails.
const SOLAR_IMG = 'https://www.hamqsl.com/solar101vhfpic.php';
const SOLAR_LINK = 'https://www.hamqsl.com/solar.html';

export default function HomePage({ navigate }) {
  return (
    <>
      <div className="home-hero">
        <div className="home-hero-inner glass-card">
          <p className="home-eyebrow">EM85au · ITU 8 · CQ 4</p>
          <h1 className="home-headline">NK4I</h1>
        </div>
      </div>

      {/* ── Band conditions ── */}
      <section className="page" aria-labelledby="bands-title">
        <p className="section-label">Right now</p>
        <h2 id="bands-title" className="section-title">Band Conditions</h2>
        <div className="section-divider" />

        <div className="solar-card glass-card">
          <a href={SOLAR_LINK} target="_blank" rel="noopener noreferrer">
            <img
              src={SOLAR_IMG}
              alt="Current solar and band conditions"
              className="solar-img"
              loading="lazy"
              onError={(e) => {
                e.currentTarget.closest('.solar-card').style.display = 'none';
              }}
            />
          </a>
          <p className="solar-credit">Solar data courtesy of hamqsl.com</p>
        </div>
      </section>

      {/* ── Sections ── */}
      <section className="page" aria-labelledby="sections-title">
        <p className="section-label">Browse by topic</p>
        <h2 id="sections-title" className="section-title">Sections</h2>
        <div className="section-divider" />

        <div className="section-grid">
          {SECTIONS.map((section) => (
            <button
              key={section.key}
              className="section-card glass-card"
              onClick={() => navigate(section.key)}
            >
              <span className="section-card-count">
                {countInSection(section.key)}
              </span>
              <span className="section-card-title">{section.label}</span>
              <span className="section-card-blurb">{section.blurb}</span>
              <span className="section-card-more" aria-hidden="true">
                View all →
              </span>
            </button>
          ))}
        </div>
      </section>
    </>
  );
}
